// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1VXO-","amount":"Amount_amount__34PBO","tip":"Amount_tip__23rNG","tipHeader":"Amount_tipHeader__pU-0D","tipsWrap":"Amount_tipsWrap__TwK0u"};